module.exports = __webpack_public_path__ + "static/media/image-4@2x.21fb7a58.png";